import "../shared/klaro_config"
import * as klaro from "klaro"

window.klaro = klaro
// ES modules have no Klaro script tag from which to discover the configuration.
klaro.setup(window.klaroConfig)

class Watcher {
  update(obj, name, data) {
    if (name == "applyConsents") {
      location.reload()
    }
  }
}

klaro.getManager(window.klaroConfig).watch(new Watcher())
